import React, {
  DetailedHTMLProps,
  InputHTMLAttributes,
  LabelHTMLAttributes,
} from "react";
import classNames from "classnames";
import "./styles.scss";

type Props = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  error?: string;
  labelText?: string;
  inlineLabel?: boolean;
  onfocus?: boolean;
  labelProps?: DetailedHTMLProps<
    LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >;
  stylesDiv?: string;
  icon?: string;
  iconColor?: string;
  image?: string;
};

const Input: React.FC<Props> = ({
  error,
  labelText,
  labelProps,
  inlineLabel,
  stylesDiv,
  iconColor,
  icon,
  image,
  ...props
}) => {
  const { className: labelClassName, ...restOfLabelProps } = labelProps!;
  const { className: inputClassName, ...inputProps } = props;
  return (
    <div className={`floating-input mb-3 relative  ${stylesDiv}`}>
      <input
        className={classNames(
          "border border-gray-200 focus:outline-none rounded-md focus:border-blue-500 focus:shadow-sm w-full p-3 h-14 ",
          inputClassName,
          error ? "text-red-500 border-red-300" : null
        )}
        {...inputProps}
      />
      {labelText ? (
        <label
          htmlFor={inputProps.id}
          className={classNames(
            "card-subtitle absolute top-0 left-0 px-3 py-5 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out ",
            labelClassName,
            error ? "text-red-500" : null
          )}
          {...restOfLabelProps}
        >
          {labelText}
        </label>
      ) : null}
    </div>
  );
};
Input.defaultProps = {
  labelProps: {},
};

export default Input;
